/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S2_Cancel_TermInputs */

const tr_iade_iptal_s2_cancel_term = /** @type {(inputs: Iade_Iptal_S2_Cancel_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İptal:`)
};

const en_iade_iptal_s2_cancel_term = /** @type {(inputs: Iade_Iptal_S2_Cancel_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation:`)
};

const de_iade_iptal_s2_cancel_term = /** @type {(inputs: Iade_Iptal_S2_Cancel_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kündigung:`)
};

const ru_iade_iptal_s2_cancel_term = /** @type {(inputs: Iade_Iptal_S2_Cancel_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена:`)
};

/**
* | output |
* | --- |
* | "Cancellation:" |
*
* @param {Iade_Iptal_S2_Cancel_TermInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s2_cancel_term = /** @type {((inputs?: Iade_Iptal_S2_Cancel_TermInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S2_Cancel_TermInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s2_cancel_term(inputs)
	if (locale === "de") return de_iade_iptal_s2_cancel_term(inputs)
	if (locale === "ru") return ru_iade_iptal_s2_cancel_term(inputs)
	return tr_iade_iptal_s2_cancel_term(inputs)
});